import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  className?: string;
  size?: 'default' | 'large';
  isPurchaseButton?: boolean;
}
export function CTAButton({
  children,
  href = 'https://checkout.beprofy.online/cart/42772312981552:1',
  onClick,
  variant = 'primary',
  className = '',
  size = 'large',
  isPurchaseButton = false
}: CTAButtonProps) {
  const baseStyles = 'font-bold rounded-lg transition-all duration-200 hover:scale-105 active:scale-95 shadow-xl hover:shadow-2xl text-center inline-block cursor-pointer';
  // TODOS los botones son VERDES ahora
  const variantStyles = {
    primary: 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white',
    secondary: 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white'
  };
  const sizeStyles = {
    default: 'px-8 py-4 text-lg',
    large: 'px-12 py-6 text-xl md:text-2xl'
  };
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    } else if (!isPurchaseButton) {
      e.preventDefault();
      const purchaseSection = document.getElementById('purchase-section');
      if (purchaseSection) {
        purchaseSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  return <a href={isPurchaseButton ? href : '#purchase-section'} onClick={handleClick} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} role="button" aria-label={typeof children === 'string' ? children : 'Comprar ahora'} data-id="element-11">
      {children}
    </a>;
}